// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lateinit = null as any;
